import {PropsWithoutRef, useContext, useEffect} from "react";
import {MapContext} from "./MapContext";
import TileLayer from "ol/layer/Tile";

export const MyTileLayer = ({source, zIndex = 0}: PropsWithoutRef<any>) => {
    const {map} = useContext(MapContext);

    useEffect(() => {
        if (!map) return;


        let tileLayer = new TileLayer({
            source,
            zIndex
        })

        map.addLayer(tileLayer)
        tileLayer.setZIndex(zIndex)

        return () => {
            if (map) {
                map.removeLayer(tileLayer)
            }
        }
    }, [map])

    return null;
}